import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import './ResponsivePagination.css';

function ResponsivePagination({
  pageCount,
  currentPage,
  onPageChange,
  onFirstPage,
  onLastPage,
}) {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < 576 : false
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(max-width: 575.98px)');
    const handleChange = (event) => {
      setIsMobile(event.matches);
    };

    setIsMobile(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  const isEmpty = pageCount === 0;

  return (
    <div className="pagination-toolbar small">
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm"
        onClick={onFirstPage}
        disabled={currentPage === 0 || isEmpty}
        aria-label="Ir a la primera pagina"
      >
        {isMobile ? '<<' : 'Primero'}
      </button>

      <ReactPaginate
        previousLabel={isMobile ? '<' : 'Anterior'}
        nextLabel={isMobile ? '>' : 'Siguiente'}
        breakLabel={'...'}
        pageCount={pageCount}
        marginPagesDisplayed={isMobile ? 1 : 2}
        pageRangeDisplayed={isMobile ? 1 : 5}
        onPageChange={onPageChange}
        forcePage={currentPage}
        renderOnZeroPageCount={null}
        containerClassName={'pagination-list'}
        activeClassName={'active'}
        disabledClassName={'disabled'}
      />

      <button
        type="button"
        className="btn btn-outline-secondary btn-sm"
        onClick={onLastPage}
        disabled={isEmpty || currentPage >= pageCount - 1}
        aria-label="Ir a la ultima pagina"
      >
        {isMobile ? '>>' : 'Ultimo'}
      </button>
    </div>
  );
}

export default ResponsivePagination;
